"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var mediaQuery_1 = require("../systems/mediaQuery");

var flexMaps_1 = require("../constants/flexMaps");

var flexSystem = function flexSystem(props) {
  var styles = {};
  styles['display'] = props && props.inline ? 'flex-inline' : 'flex';

  if (props) {
    if (props.direction) {
      styles['flex-direction'] = props.direction;
    }

    if (props.direction && props.reverse) {
      styles['flex-direction'] += '-reverse';
    }

    if (props.justifyContent) {
      styles['justify-content'] = flexMaps_1.flexContentMap[props.justifyContent];
    }

    if (props.alignContent) {
      styles['align-content'] = flexMaps_1.flexContentMap[props.alignContent];
    }

    if (props.alignItems) {
      styles['align-items'] = flexMaps_1.flexItemsMap[props.alignItems];
    }

    if (props.wrap) {
      styles['flex-wrap'] = 'wrap';
    }

    if (props.wrapReverse) {
      styles['flex-wrap'] += '-reverse';
    }
  }

  return styles;
};

var Flex = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n ", ";\n"], ["\n  ", ";\n ", ";\n"])), function (props) {
  return __assign({}, flexSystem(props));
}, function (props) {
  return mediaQuery_1.default(props, [flexSystem]);
});
exports.default = Flex;
var templateObject_1;